<template>
  <div>
    <v-form ref="formFile"
            class="row"
    >
      <div class="pl-3">
        <v-file-input
          v-model="localOverlay.file"
          hide-input
          accept=".png,.svg,image/svg+xml,image/png"
          @change="updateOverlayFile($event)"
        />
      </div>
      <div class="row row--center pl-3">
        <v-text-field disabled
                      v-model="overlay.fileName"
                      class="pr-5"
        ></v-text-field>
        <v-btn
          v-if="overlay.fileName"
          icon
          class="mr-4"
          @click="$emit('remove-overlay-file')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import {HubConnection} from "@microsoft/signalr";
import {DeepCopy} from "../../services/deep-copy";
import {ConnectionService} from "../../services/connection.service";
import axios from "axios";

export default {
  name:  "OverlayFileForm",
  props: {
    connection: HubConnection,
    overlay:    Object,
  },
  data: function () {
    return {
      localOverlay: DeepCopy(this.overlay),
      rules:        {
        required: (value) => !!value || "Required."
      },
    };
  },
  watch: {
    overlay(newOverlay) {
      this.localOverlay = DeepCopy(newOverlay);
    },
  },
  mounted() {
    this.localOverlay = DeepCopy(this.overlay);
  },
  methods: {
    updateOverlayFile(file) {
      const url = "/api/Settings/UpdateOverlayFile";
      const formData = new FormData();
      formData.append("svgFile", file, file.name);
      return axios
        .post(ConnectionService.getUrl(url), formData)
        .then((response) => {
          if (response.data.resultKind === "Success") {
            this.$emit("overlay-updated", response.data.entity);
          } else {
            this.$emit("failure", response.data.reason);
          }
        })
        .catch((reason) => {
          this.$emit("failure", reason);
        });
    }
  },
};
</script>